import { createFileRoute } from '@tanstack/react-router'

import { withRecordParam } from '@/components/kit/list/record-param'
import { transactionFilters } from '@/features/money/transaction-filters'
import { TransactionsList } from '@/features/money/transactions-list'

/**
 * The ledger already carried its own standalone title, description and URL state;
 * it just had no route to be reached from. Rendered with no props so it uses those
 * defaults and keeps its filters in the URL.
 */
export const Route = createFileRoute('/_app/transactions')({
    validateSearch: withRecordParam(transactionFilters.parse, 'tx'),
    component: TransactionsList,
    staticData: { crumb: 'Transactions' }
})
